import { Component, OnInit } from "@angular/core";

import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { CoreConfigService } from "@core/services/config.service";
import { RoleService } from "app/services/role.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-not-authorized",
  templateUrl: "./not-authorized.component.html",
  styleUrls: ["./not-authorized.component.scss"],
})
export class NotAuthorizedComponent implements OnInit {
  public coreConfig: any;
  public defaultRoute: string = "/utrav/settings";

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   * @param {RoleService} roleService
   * @param {Router} router
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    private roleService: RoleService,
    private router: Router
  ) {
    this._unsubscribeAll = new Subject();
    // Déterminer la route par défaut selon les permissions de l'utilisateur
    const currentPermissions = this.roleService.getCurrentPermissions();
    console.log("🚫 NotAuthorized - Permissions actuelles:", currentPermissions);
    console.log("🚫 NotAuthorized - Nombre de permissions:", currentPermissions.length);
    this.defaultRoute = this.roleService.getDefaultRouteForUser();
    console.log("🚫 NotAuthorized - Route par défaut calculée:", this.defaultRoute);

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
      this.coreConfig = config;
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  /**
   * Naviguer vers la page par défaut accessible à l'utilisateur
   */
  goToDefaultPage(): void {
    // Recalculer au cas où les permissions auraient changé
    const currentPermissions = this.roleService.getCurrentPermissions();
    console.log("🔄 goToDefaultPage - Permissions actuelles:", currentPermissions);
    this.defaultRoute = this.roleService.getDefaultRouteForUser();
    console.log("🔄 goToDefaultPage - Navigation vers:", this.defaultRoute);
    this.router.navigate([this.defaultRoute]);
  }
}
